export default __webpack_public_path__ + "static/media/luntik.d745401d.png";